import { useEffect, useState } from "react";
import useSwConfigVars from "../../../../../customHooks/useSwConfigs";
import Input from "../../../../../stories/Input/Input";
import { LicenseTypes, Operation } from "../../../../../utils/Enum.types";
import Navbar from "../../../../common/layout/Navbar";
import {
  SwConfigQueryType,
  UpdateSwConfigVariablesData,
  UpdateSwConfigVariablesVar,
} from "../../masters/items/configurations/queries/type";
import { SwConfigBannerType } from "../../users/ResetUserPassword/queries/types";
import { msgType } from "../../../../../utils/types";
import { EMPTY_STRING, emptyMessage } from "../../../../../utils/constants";
import { useMutation } from "@apollo/client";
import { UpdateSwConfigVariables } from "../../masters/items/configurations/queries/mutations";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { Button } from "../../../../../stories/Button/Button";
import { GetSwConfigVariables } from "../../masters/items/configurations/queries/queries";
import MessageModal from "../../../../../customComponents/MessageModal";
import { Title } from "../../../../../stories/Title/Title";
import { useNavigate } from "react-router-dom";
import TextArea from "../../../../../stories/TextArea/TextArea";

const BannerConfig = () => {
  const [banner, setBanner] = useState<string>("");
  const [message, setMessage] = useState<msgType>(emptyMessage);
  const navigate = useNavigate();
  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();

  const { configData } = useSwConfigVars({
    queryType: SwConfigQueryType.BY_CONFIG_KEY,
    strValue: [SwConfigBannerType.BANNER],
    intValue: 0,
  });

  const [updateSwConfig, { loading: updateLoading }] = useMutation<
    UpdateSwConfigVariablesData,
    UpdateSwConfigVariablesVar
  >(UpdateSwConfigVariables, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const handleUpdateSwConfig = async () => {
    try {
      if (customer_id) {
        const updateConfig = updateSwConfig({
          variables: {
            customerID: customer_id,
            input: (configData.data?.GetSwConfigVariables || []).map(
              (pageSwDetail) => ({
                id: pageSwDetail.id!,
                config_key: pageSwDetail.configKey,
                booleanValue: pageSwDetail.booleanValue,
                integerValue: pageSwDetail.integerValue,
                doubleValue: pageSwDetail.doubleValue,
                str1Value: banner,
                str2Value: pageSwDetail.str2Value,
                dateValue: pageSwDetail.dateValue,
              })
            ),
            user_details,
          },
          refetchQueries: [
            {
              query: GetSwConfigVariables,
              variables: {
                customerID: customer_id,
                input: {
                  queryType: SwConfigQueryType.ALL_CONFIGS,
                  strValue: EMPTY_STRING,
                  intValue: 0,
                },
              },
            },
          ],
        });

        const { data } = await updateConfig;
        if (data) {
          setMessage({
            flag: true,
            message: "Configuration Saved Successfully",
            operation: Operation.CREATE,
          });
        }
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };

  let banner1 = "";

  if (configData && configData.data) {
    const bannerData = configData.data.GetSwConfigVariables;
    if (bannerData && bannerData.length > 0) {
      const bannerItem = bannerData.find(
        (item) => item.configKey === SwConfigBannerType.BANNER
      );
      if (bannerItem && bannerItem.booleanValue) {
        banner1 = bannerItem.str1Value || "";
      }
    }
  }

  const handleClose = () => {
    setMessage(emptyMessage);
  };

  return (
    <>
      <Navbar NavType={LicenseTypes.NONE} />
      <Title>Banner Configuration</Title>

      <div className="banner-config">
        <div className="banner-config__content">
          <div className="banner-config__content--textarea">
     <TextArea
          rows={10}
            type="text"
            onChange={(e) => {
              setBanner(e.target.value);
            }}
            value={banner ? banner : banner1}
          />
          </div>
       <Button
          mode="save"
          onClick={() => {
            handleUpdateSwConfig();
          }}
        />
        <Button mode="clear" onClick={handleClose} />
        <Button mode="back" onClick={() => navigate(-1)} />
        </div>
      
      </div>

      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />
    </>
  );
};

export default BannerConfig;
